import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MyDatePickerModule } from 'mydatepicker';
import { CovanceDatePickerComponent } from './covance-date-picker.component';

@NgModule({
    declarations: [CovanceDatePickerComponent],
    imports: [SharedModule, MyDatePickerModule],
    exports: [CovanceDatePickerComponent]
})
export class CovanceDatePickerModule { }